import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BarcodeSnapScanner from "./barcode";
import Activatelens from "./activatelens";
import Activatelens_2 from "./activatelens_2";
import BarcodeSnapScanner_2 from "./barcode_2";
import Terms_Condition from "./T&C/privacy";
// import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Router>
        <Routes>
            <Route path="/" element={<BarcodeSnapScanner />} />
            {/* <Route path="/lens" element={<Activatelens />} /> */}
            <Route path="/lens/:lensId/:groupId/:barcode" element={<Activatelens />} />

            <Route path="/barcode" element={<BarcodeSnapScanner_2 />} />
            <Route path="/snapchatlens/:lensId/:groupId/:barcode" element={<Activatelens_2 />} />
            <Route path="/privacy" element={<Terms_Condition />} />

        </Routes>
    </Router>
);
